import React from "react";
import "./table.scss";

function Table() {
  const tableData = [
    {
      benefits: "Early Access",
      oneXone: "/assets/images/Table Icons/Checkbox.png",
      twoXtwo: "/assets/images/Table Icons/Checkbox.png",
      fourXfour: "/assets/images/Table Icons/Checkbox.png",
      eightXeight: "/assets/images/Table Icons/Checkbox.png",
      tenXten: "/assets/images/Table Icons/Checkbox.png",
    },
    {
      benefits: "Purchase Discount  ",
      oneXone: "/assets/images/Table Icons/Checkbox.png",
      twoXtwo: "/assets/images/Table Icons/Checkbox.png",
      fourXfour: "/assets/images/Table Icons/Checkbox.png",
      eightXeight: "/assets/images/Table Icons/Checkbox.png",
      tenXten: "/assets/images/Table Icons/Checkbox.png",
    },
    {
      benefits: "Lucky Draw  ",
      oneXone: "/assets/images/Table Icons/Checkbox.png",
      twoXtwo: "/assets/images/Table Icons/Checkbox.png",
      fourXfour: "/assets/images/Table Icons/Checkbox.png",
      eightXeight: "/assets/images/Table Icons/Checkbox.png",
      tenXten: "/assets/images/Table Icons/Checkbox.png",
    },
    {
      benefits: "Expressive Emblems  ",
      oneXone: "/assets/images/Table Icons/Checkbox.png",
      twoXtwo: "/assets/images/Table Icons/Checkbox.png",
      fourXfour: "/assets/images/Table Icons/Checkbox.png",
      eightXeight: "/assets/images/Table Icons/Checkbox.png",
      tenXten: "/assets/images/Table Icons/Checkbox.png",
    },
    {
      benefits: "Business Starter Pack  ",
      oneXone: "/assets/images/Table Icons/Checkbox.png",
      twoXtwo: "/assets/images/Table Icons/Checkbox.png",
      fourXfour: "/assets/images/Table Icons/Checkbox.png",
      eightXeight: "/assets/images/Table Icons/Checkbox.png",
      tenXten: "/assets/images/Table Icons/Checkbox.png",
    },
    {
      benefits: "Real-world Discount  ",
      oneXone: "/assets/images/Table Icons/Checkbox.png",
      twoXtwo: "/assets/images/Table Icons/Checkbox.png",
      fourXfour: "/assets/images/Table Icons/Checkbox.png",
      eightXeight: "/assets/images/Table Icons/Checkbox.png",
      tenXten: "/assets/images/Table Icons/Checkbox.png",
    },
    {
      benefits: "Astrality Merchandise Discount  ",
      oneXone: "/assets/images/Table Icons/Checkbox.png",
      twoXtwo: "/assets/images/Table Icons/Checkbox.png",
      fourXfour: "/assets/images/Table Icons/Checkbox.png",
      eightXeight: "/assets/images/Table Icons/Checkbox.png",
      tenXten: "/assets/images/Table Icons/Checkbox.png",
    },
    {
      benefits: "Local Discount  ",
      oneXone: "/assets/images/Table Icons/Checkbox.png",
      twoXtwo: "/assets/images/Table Icons/Checkbox.png",
      fourXfour: "/assets/images/Table Icons/Checkbox.png",
      eightXeight: "/assets/images/Table Icons/Checkbox.png",
      tenXten: "/assets/images/Table Icons/Checkbox.png",
    },
    // New Section for red X
    {
      benefits: "Premium Staking  ",
      oneXone: "/assets/images/Table Icons/Checkbox-X.png",
      twoXtwo: "/assets/images/Table Icons/Checkbox.png",
      fourXfour: "/assets/images/Table Icons/Checkbox.png",
      eightXeight: "/assets/images/Table Icons/Checkbox.png",
      tenXten: "/assets/images/Table Icons/Checkbox.png",
    },
    {
      benefits: "Transaction Disocunt  ",
      oneXone: "/assets/images/Table Icons/Checkbox-X.png",
      twoXtwo: "/assets/images/Table Icons/Checkbox.png",
      fourXfour: "/assets/images/Table Icons/Checkbox.png",
      eightXeight: "/assets/images/Table Icons/Checkbox.png",
      tenXten: "/assets/images/Table Icons/Checkbox.png",
    },
    {
      benefits: "Exclusive Content Acess  ",
      oneXone: "/assets/images/Table Icons/Checkbox-X.png",
      twoXtwo: "/assets/images/Table Icons/Checkbox.png",
      fourXfour: "/assets/images/Table Icons/Checkbox.png",
      eightXeight: "/assets/images/Table Icons/Checkbox.png",
      tenXten: "/assets/images/Table Icons/Checkbox.png",
    },
    {
      benefits: "Additional Affiliate Commission  ",
      oneXone: "/assets/images/Table Icons/Checkbox-X.png",
      twoXtwo: "/assets/images/Table Icons/Checkbox.png",
      fourXfour: "/assets/images/Table Icons/Checkbox.png",
      eightXeight: "/assets/images/Table Icons/Checkbox.png",
      tenXten: "/assets/images/Table Icons/Checkbox.png",
    },
    {
      benefits: "Branding Assistancet  ",
      oneXone: "/assets/images/Table Icons/Checkbox-X.png",
      twoXtwo: "/assets/images/Table Icons/Checkbox.png",
      fourXfour: "/assets/images/Table Icons/Checkbox.png",
      eightXeight: "/assets/images/Table Icons/Checkbox.png",
      tenXten: "/assets/images/Table Icons/Checkbox.png",
    },
    {
      benefits: "Exclusive Networking Events  ",
      oneXone: "/assets/images/Table Icons/Checkbox-X.png",
      twoXtwo: "/assets/images/Table Icons/Checkbox.png",
      fourXfour: "/assets/images/Table Icons/Checkbox.png",
      eightXeight: "/assets/images/Table Icons/Checkbox.png",
      tenXten: "/assets/images/Table Icons/Checkbox.png",
    },
    {
      benefits: "VIP Event Access  ",
      oneXone: "/assets/images/Table Icons/Checkbox-X.png",
      twoXtwo: "/assets/images/Table Icons/Checkbox.png",
      fourXfour: "/assets/images/Table Icons/Checkbox.png",
      eightXeight: "/assets/images/Table Icons/Checkbox.png",
      tenXten: "/assets/images/Table Icons/Checkbox.png",
    },
    {
      benefits: "Exclusive Astrality Subscription Box  ",
      oneXone: "/assets/images/Table Icons/Checkbox-X.png",
      twoXtwo: "/assets/images/Table Icons/Checkbox.png",
      fourXfour: "/assets/images/Table Icons/Checkbox.png",
      eightXeight: "/assets/images/Table Icons/Checkbox.png",
      tenXten: "/assets/images/Table Icons/Checkbox.png",
    },
    // New section for X on second column
    {
      benefits: "Astrality Asset Agent Pass  ",
      oneXone: "/assets/images/Table Icons/Checkbox-X.png",
      twoXtwo: "/assets/images/Table Icons/Checkbox-X.png",
      fourXfour: "/assets/images/Table Icons/Checkbox.png",
      eightXeight: "/assets/images/Table Icons/Checkbox.png",
      tenXten: "/assets/images/Table Icons/Checkbox.png",
    },
    {
      benefits: "In-store VIP Access  ",
      oneXone: "/assets/images/Table Icons/Checkbox-X.png",
      twoXtwo: "/assets/images/Table Icons/Checkbox-X.png",
      fourXfour: "/assets/images/Table Icons/Checkbox.png",
      eightXeight: "/assets/images/Table Icons/Checkbox.png",
      tenXten: "/assets/images/Table Icons/Checkbox.png",
    },
    {
      benefits: "Exclusive Club Access  ",
      oneXone: "/assets/images/Table Icons/Checkbox-X.png",
      twoXtwo: "/assets/images/Table Icons/Checkbox-X.png",
      fourXfour: "/assets/images/Table Icons/Checkbox.png",
      eightXeight: "/assets/images/Table Icons/Checkbox.png",
      tenXten: "/assets/images/Table Icons/Checkbox.png",
    },
    {
      benefits: "Upgrade Discount  ",
      oneXone: "/assets/images/Table Icons/Checkbox-X.png",
      twoXtwo: "/assets/images/Table Icons/Checkbox-X.png",
      fourXfour: "/assets/images/Table Icons/Checkbox.png",
      eightXeight: "/assets/images/Table Icons/Checkbox.png",
      tenXten: "/assets/images/Table Icons/Checkbox.png",
    },
    {
      benefits: "Unique Architecture  ",
      oneXone: "/assets/images/Table Icons/Checkbox-X.png",
      twoXtwo: "/assets/images/Table Icons/Checkbox-X.png",
      fourXfour: "/assets/images/Table Icons/Checkbox.png",
      eightXeight: "/assets/images/Table Icons/Checkbox.png",
      tenXten: "/assets/images/Table Icons/Checkbox.png",
    },
    {
      benefits: "Digital Asset Insurance  ",
      oneXone: "/assets/images/Table Icons/Checkbox-X.png",
      twoXtwo: "/assets/images/Table Icons/Checkbox-X.png",
      fourXfour: "/assets/images/Table Icons/Checkbox.png",
      eightXeight: "/assets/images/Table Icons/Checkbox.png",
      tenXten: "/assets/images/Table Icons/Checkbox.png",
    },
    {
      benefits: "Priority Support  ",
      oneXone: "/assets/images/Table Icons/Checkbox-X.png",
      twoXtwo: "/assets/images/Table Icons/Checkbox-X.png",
      fourXfour: "/assets/images/Table Icons/Checkbox.png",
      eightXeight: "/assets/images/Table Icons/Checkbox.png",
      tenXten: "/assets/images/Table Icons/Checkbox.png",
    },
    {
      benefits: "Influencer Collaborations  ",
      oneXone: "/assets/images/Table Icons/Checkbox-X.png",
      twoXtwo: "/assets/images/Table Icons/Checkbox-X.png",
      fourXfour: "/assets/images/Table Icons/Checkbox.png",
      eightXeight: "/assets/images/Table Icons/Checkbox.png",
      tenXten: "/assets/images/Table Icons/Checkbox.png",
    },
    {
      benefits: "Premium Business Features  ",
      oneXone: "/assets/images/Table Icons/Checkbox-X.png",
      twoXtwo: "/assets/images/Table Icons/Checkbox-X.png",
      fourXfour: "/assets/images/Table Icons/Checkbox.png",
      eightXeight: "/assets/images/Table Icons/Checkbox.png",
      tenXten: "/assets/images/Table Icons/Checkbox.png",
    },
    {
      benefits: "Real-world Business Webinars  ",
      oneXone: "/assets/images/Table Icons/Checkbox-X.png",
      twoXtwo: "/assets/images/Table Icons/Checkbox-X.png",
      fourXfour: "/assets/images/Table Icons/Checkbox.png",
      eightXeight: "/assets/images/Table Icons/Checkbox.png",
      tenXten: "/assets/images/Table Icons/Checkbox.png",
    },
    {
      benefits: "Exclusive Meet-and-Greet Opportunities  ",
      oneXone: "/assets/images/Table Icons/Checkbox-X.png",
      twoXtwo: "/assets/images/Table Icons/Checkbox-X.png",
      fourXfour: "/assets/images/Table Icons/Checkbox.png",
      eightXeight: "/assets/images/Table Icons/Checkbox.png",
      tenXten: "/assets/images/Table Icons/Checkbox.png",
    },
    {
      benefits: "Astrality Retreats  ",
      oneXone: "/assets/images/Table Icons/Checkbox-X.png",
      twoXtwo: "/assets/images/Table Icons/Checkbox-X.png",
      fourXfour: "/assets/images/Table Icons/Checkbox.png",
      eightXeight: "/assets/images/Table Icons/Checkbox.png",
      tenXten: "/assets/images/Table Icons/Checkbox.png",
    },
    {
      benefits: "Exclusive Celebrity Club Access  ",
      oneXone: "/assets/images/Table Icons/Checkbox-X.png",
      twoXtwo: "/assets/images/Table Icons/Checkbox-X.png",
      fourXfour: "/assets/images/Table Icons/Checkbox-X.png",
      eightXeight: "/assets/images/Table Icons/Checkbox.png",
      tenXten: "/assets/images/Table Icons/Checkbox.png",
    },
    {
      benefits: "Exclusive Content  ",
      oneXone: "/assets/images/Table Icons/Checkbox-X.png",
      twoXtwo: "/assets/images/Table Icons/Checkbox-X.png",
      fourXfour: "/assets/images/Table Icons/Checkbox-X.png",
      eightXeight: "/assets/images/Table Icons/Checkbox.png",
      tenXten: "/assets/images/Table Icons/Checkbox.png",
    },
    {
      benefits: "Mining Access  ",
      oneXone: "/assets/images/Table Icons/Checkbox-X.png",
      twoXtwo: "/assets/images/Table Icons/Checkbox-X.png",
      fourXfour: "/assets/images/Table Icons/Checkbox-X.png",
      eightXeight: "/assets/images/Table Icons/Checkbox.png",
      tenXten: "/assets/images/Table Icons/Checkbox.png",
    },
    {
      benefits: "Exclusive Avatar & Emote ",
      oneXone: "/assets/images/Table Icons/Checkbox-X.png",
      twoXtwo: "/assets/images/Table Icons/Checkbox-X.png",
      fourXfour: "/assets/images/Table Icons/Checkbox-X.png",
      eightXeight: "/assets/images/Table Icons/Checkbox.png",
      tenXten: "/assets/images/Table Icons/Checkbox.png",
    },
    {
      benefits: "Highlighted ID  ",
      oneXone: "/assets/images/Table Icons/Checkbox-X.png",
      twoXtwo: "/assets/images/Table Icons/Checkbox-X.png",
      fourXfour: "/assets/images/Table Icons/Checkbox-X.png",
      eightXeight: "/assets/images/Table Icons/Checkbox.png",
      tenXten: "/assets/images/Table Icons/Checkbox.png",
    },
    {
      benefits: "Astrality Developer Workshops  ",
      oneXone: "/assets/images/Table Icons/Checkbox-X.png",
      twoXtwo: "/assets/images/Table Icons/Checkbox-X.png",
      fourXfour: "/assets/images/Table Icons/Checkbox-X.png",
      eightXeight: "/assets/images/Table Icons/Checkbox.png",
      tenXten: "/assets/images/Table Icons/Checkbox.png",
    },
    {
      benefits: " VR Concert Access  ",
      oneXone: "/assets/images/Table Icons/Checkbox-X.png",
      twoXtwo: "/assets/images/Table Icons/Checkbox-X.png",
      fourXfour: "/assets/images/Table Icons/Checkbox-X.png",
      eightXeight: "/assets/images/Table Icons/Checkbox.png",
      tenXten: "/assets/images/Table Icons/Checkbox.png",
    },
    {
      benefits: "Strategic Business Consultations  ",
      oneXone: "/assets/images/Table Icons/Checkbox-X.png",
      twoXtwo: "/assets/images/Table Icons/Checkbox-X.png",
      fourXfour: "/assets/images/Table Icons/Checkbox-X.png",
      eightXeight: "/assets/images/Table Icons/Checkbox.png",
      tenXten: "/assets/images/Table Icons/Checkbox.png",
    },
    {
      benefits: "Real-world Business Partnerships  ",
      oneXone: "/assets/images/Table Icons/Checkbox-X.png",
      twoXtwo: "/assets/images/Table Icons/Checkbox-X.png",
      fourXfour: "/assets/images/Table Icons/Checkbox-X.png",
      eightXeight: "/assets/images/Table Icons/Checkbox.png",
      tenXten: "/assets/images/Table Icons/Checkbox.png",
    },
    {
      benefits: "Astrality Business Leaderboards  ",
      oneXone: "/assets/images/Table Icons/Checkbox-X.png",
      twoXtwo: "/assets/images/Table Icons/Checkbox-X.png",
      fourXfour: "/assets/images/Table Icons/Checkbox-X.png",
      eightXeight: "/assets/images/Table Icons/Checkbox.png",
      tenXten: "/assets/images/Table Icons/Checkbox.png",
    },
    {
      benefits: "Sponsorship Opportunities  ",
      oneXone: "/assets/images/Table Icons/Checkbox-X.png",
      twoXtwo: "/assets/images/Table Icons/Checkbox-X.png",
      fourXfour: "/assets/images/Table Icons/Checkbox-X.png",
      eightXeight: "/assets/images/Table Icons/Checkbox.png",
      tenXten: "/assets/images/Table Icons/Checkbox.png",
    },
    {
      benefits: "Astrality Experience Center Access   ",
      oneXone: "/assets/images/Table Icons/Checkbox-X.png",
      twoXtwo: "/assets/images/Table Icons/Checkbox-X.png",
      fourXfour: "/assets/images/Table Icons/Checkbox-X.png",
      eightXeight: "/assets/images/Table Icons/Checkbox.png",
      tenXten: "/assets/images/Table Icons/Checkbox.png",
    },
    {
      benefits: "Revenue Sharing  ",
      oneXone: "/assets/images/Table Icons/Checkbox-X.png",
      twoXtwo: "/assets/images/Table Icons/Checkbox-X.png",
      fourXfour: "/assets/images/Table Icons/Checkbox-X.png",
      eightXeight: "/assets/images/Table Icons/Checkbox.png",
      tenXten: "/assets/images/Table Icons/Checkbox.png",
    },
    {
      benefits: "Exclusive Aura  ",
      oneXone: "/assets/images/Table Icons/Checkbox-X.png",
      twoXtwo: "/assets/images/Table Icons/Checkbox-X.png",
      fourXfour: "/assets/images/Table Icons/Checkbox-X.png",
      eightXeight: "/assets/images/Table Icons/Checkbox.png",
      tenXten: "/assets/images/Table Icons/Checkbox.png",
    },
    {
      benefits: "Whitelist Spot ",
      oneXone: "/assets/images/Table Icons/Checkbox-X.png",
      twoXtwo: "/assets/images/Table Icons/Checkbox-X.png",
      fourXfour: "/assets/images/Table Icons/Checkbox-X.png",
      eightXeight: "/assets/images/Table Icons/Checkbox.png",
      tenXten: "/assets/images/Table Icons/Checkbox.png",
    },
    {
      benefits: "Personalized Avatar Creator  ",
      oneXone: "/assets/images/Table Icons/Checkbox-X.png",
      twoXtwo: "/assets/images/Table Icons/Checkbox-X.png",
      fourXfour: "/assets/images/Table Icons/Checkbox-X.png",
      eightXeight: "/assets/images/Table Icons/Checkbox.png",
      tenXten: "/assets/images/Table Icons/Checkbox.png",
    },
    {
      benefits: "Astrality Board Meetings  ",
      oneXone: "/assets/images/Table Icons/Checkbox-X.png",
      twoXtwo: "/assets/images/Table Icons/Checkbox-X.png",
      fourXfour: "/assets/images/Table Icons/Checkbox-X.png",
      eightXeight: "/assets/images/Table Icons/Checkbox.png",
      tenXten: "/assets/images/Table Icons/Checkbox.png",
    },
    {
      benefits: "Real-world Conference Passes  ",
      oneXone: "/assets/images/Table Icons/Checkbox-X.png",
      twoXtwo: "/assets/images/Table Icons/Checkbox-X.png",
      fourXfour: "/assets/images/Table Icons/Checkbox-X.png",
      eightXeight: "/assets/images/Table Icons/Checkbox.png",
      tenXten: "/assets/images/Table Icons/Checkbox.png",
    },
    {
      benefits: "Business Collaboration  ",
      oneXone: "/assets/images/Table Icons/Checkbox-X.png",
      twoXtwo: "/assets/images/Table Icons/Checkbox-X.png",
      fourXfour: "/assets/images/Table Icons/Checkbox-X.png",
      eightXeight: "/assets/images/Table Icons/Checkbox.png",
      tenXten: "/assets/images/Table Icons/Checkbox.png",
    },
    {
      benefits: "Astrality Advisory Board  ",
      oneXone: "/assets/images/Table Icons/Checkbox-X.png",
      twoXtwo: "/assets/images/Table Icons/Checkbox-X.png",
      fourXfour: "/assets/images/Table Icons/Checkbox-X.png",
      eightXeight: "/assets/images/Table Icons/Checkbox-X.png",
      tenXten: "/assets/images/Table Icons/Checkbox.png",
    },
    {
      benefits: "Mysterious Perk  ",
      oneXone: "/assets/images/Table Icons/Checkbox-X.png",
      twoXtwo: "/assets/images/Table Icons/Checkbox-X.png",
      fourXfour: "/assets/images/Table Icons/Checkbox-X.png",
      eightXeight: "/assets/images/Table Icons/Checkbox-X.png",
      tenXten: "/assets/images/Table Icons/Checkbox.png",
    },
  ];

  return (
    <div>
      <div className="outer ">
        <div class="table-responsive">
          <table class="table table-striped table-dark ">
            <thead className="table-head ">
              <tr>
                <th scope="col">Benefits</th>
                <th scope="col">1x1 land</th>
                <th scope="col">2x2 land</th>
                <th scope="col">4x4 land</th>
                <th scope="col">8x8 land</th>
                <th scope="col">10x10 land</th>
              </tr>
            </thead>
            <tbody className="table-body">
              {tableData.map((item, index) => {
                return (
                  <tr>
                    <td>{item.benefits}</td>
                    <td>
                      <img src={item.oneXone} alt="checkbox" />
                    </td>
                    <td>
                      <img src={item.twoXtwo} alt="checkbox" />
                    </td>
                    <td>
                      <img src={item.fourXfour} alt="checkbox" />
                    </td>
                    <td>
                      <img src={item.eightXeight} alt="checkbox" />
                    </td>
                    <td>
                      <img src={item.tenXten} alt="checkbox" />
                    </td>
                  </tr>
                );
              })}
              <tr>
                <td></td>
                <td>
                  <button>Buy Now</button>
                </td>
                <td>
                  <button>Buy Now</button>
                </td>
                <td>
                  <button>Buy Now</button>
                </td>
                <td>
                  <button>Buy Now</button>
                </td>
                <td>
                  <button>Buy Now</button>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
}

export default Table;
